import { DocumentMetadata } from '@/modules/layouts/components/DocumentMetadata';
import { SHORTLIST_OG_IMAGE_PATH } from '@/modules/public-shortlist/constants';
import {
  formatShortlistCandidateOgTitle,
  formatShortlistOgTitle,
  SHORTLIST_OG_DESCRIPTION,
} from '@/modules/public-shortlist/shortlistCopy';

interface ShortlistListDocumentMetadataProps {
  companyName: string;
  jobTitle: string;
}

export function ShortlistListDocumentMetadata({
  companyName,
  jobTitle,
}: ShortlistListDocumentMetadataProps) {
  return (
    <DocumentMetadata
      title={formatShortlistOgTitle({ companyName, jobTitle })}
      description={SHORTLIST_OG_DESCRIPTION}
      imagePath={SHORTLIST_OG_IMAGE_PATH}
    />
  );
}

interface ShortlistCandidateDocumentMetadataProps {
  companyName: string;
  fullName: string;
  jobTitle: string;
}

export function ShortlistCandidateDocumentMetadata({
  companyName,
  fullName,
  jobTitle,
}: ShortlistCandidateDocumentMetadataProps) {
  return (
    <DocumentMetadata
      title={formatShortlistCandidateOgTitle({
        companyName,
        fullName,
        jobTitle,
      })}
      description={SHORTLIST_OG_DESCRIPTION}
      imagePath={SHORTLIST_OG_IMAGE_PATH}
    />
  );
}
